import React from 'react';
import './Image.scss'
export type radius = 'mfg-rounded' | 'mfg-circle' | 'mfg-sharp';
export type align = 'mfg-left' | 'mfg-enter' | 'mfg-right';

export interface Props {
  ImageClass?: any;
  ImageId?: any;
  ImagePath: any;
  ImageAlt: any;
  ImageRadius?: radius;
  ImageAlign?: align;
  style?: React.CSSProperties;
}

const Image = ({
  ImageClass,
  ImageId,
  ImagePath,
  ImageAlt,
  ImageRadius = 'mfg-sharp',
  ImageAlign = 'mfg-left',
  style
}:Props) => {
  return (
    <img style={style && style} src={ImagePath} className={`mfg-img${ImageClass ? (' ' + ImageClass) : ''}${ImageRadius ?(' ' + ImageRadius) : ''}${ImageAlign ?(' ' + ImageAlign) : ''}`} id={ImageId} alt={ImageAlt}/>
  )
}

export default Image
